export function sortByPriority(items) {
    return items.slice().sort(function (a, b) {
        var _a, _b;
        if (b.orderPriority !== a.orderPriority) {
            return Math.sign((_a = b.orderPriority, (_a !== null && _a !== void 0 ? _a : 0)) - (_b = a.orderPriority, (_b !== null && _b !== void 0 ? _b : 0)));
        }
        return b.id < a.id ? 1 : -1;
    });
}
//# sourceMappingURL=utils.js.map